import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetData_queue_id = z.any()
export type TagsGetData_queue_id = z.infer<typeof tagsGetData_queue_id>

export const descriptionGetData_queue_id = z.any()
export type DescriptionGetData_queue_id = z.infer<typeof descriptionGetData_queue_id>

export const paramsGetData_queue_id = z.object({ "id": z.string() })
export type ParamsGetData_queue_id = z.infer<typeof paramsGetData_queue_id>

export const responseGetData_queue_id = z.object({ "payload": z.object({ "createdAt": z.string().datetime({ offset: true }), "buildingId": z.string(), "type": z.string(), "data": z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}), "id": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetData_queue_id = z.infer<typeof responseGetData_queue_id>

interface IGetData_queue_id extends BaseMethodType {
  tags: TagsGetData_queue_id,
  description: DescriptionGetData_queue_id,
  params: ParamsGetData_queue_id,
  response: ResponseGetData_queue_id
}
export const tagsDeleteData_queue_id = z.any()
export type TagsDeleteData_queue_id = z.infer<typeof tagsDeleteData_queue_id>

export const descriptionDeleteData_queue_id = z.any()
export type DescriptionDeleteData_queue_id = z.infer<typeof descriptionDeleteData_queue_id>

export const paramsDeleteData_queue_id = z.object({ "id": z.string() })
export type ParamsDeleteData_queue_id = z.infer<typeof paramsDeleteData_queue_id>

export const responseDeleteData_queue_id = z.any()
export type ResponseDeleteData_queue_id = z.infer<typeof responseDeleteData_queue_id>

interface IDeleteData_queue_id extends BaseMethodType {
  tags: TagsDeleteData_queue_id,
  description: DescriptionDeleteData_queue_id,
  params: ParamsDeleteData_queue_id,
  response: ResponseDeleteData_queue_id
}
export const URL = '/data-queue/:id'
export const validation = {
  get: {
    tags: tagsGetData_queue_id,
    description: descriptionGetData_queue_id,
    params: paramsGetData_queue_id,
    response: responseGetData_queue_id
  },
  delete: {
    tags: tagsDeleteData_queue_id,
    description: descriptionDeleteData_queue_id,
    params: paramsDeleteData_queue_id,
    response: responseDeleteData_queue_id
  }
}
export interface Data_queue_id extends BaseRouteType {
  get: IGetData_queue_id,
  delete: IDeleteData_queue_id
}